import { SPEEDS } from './speeds';

export const ANIMATION = {
  SPEEDS,
};

export type ANIMATION_SPEEDS = (typeof SPEEDS)[keyof typeof SPEEDS];
